export const EXPERIENCE_RADII=[5,10,25,50,100] as const;
export function experienceRadius(value:number=25):number {
  return EXPERIENCE_RADII.some(radius=>radius===value)?value:25;
}
